// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'table';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.088 2.088h13.896c.864 0 1.512.648 1.512 1.512v10.872c0 .864-.648 1.512-1.512 1.512H2.088c-.864 0-1.512-.648-1.512-1.512V3.528c0-.792.648-1.44 1.512-1.44zM.576 5.472h16.848M.576 10.656h16.848M6.192 5.472v10.44m5.616-10.44v10.44'
  />
);

export const viewBox = '0 0 18 18';
